import { GridSortModel } from '@mui/x-data-grid';
import { DbRegistration } from '@/shared/api/orval/models';

export interface IUserRegistrationsViewModel {
  sortModel: GridSortModel;
  selectRegistration: (registration: DbRegistration) => void;
  registrations: DbRegistration[];
}

export const token = Symbol.for('IUserRegistrationsViewModel');
